export default {
  energy_provider: {
    type: "categorical",
    label: "Energy Provider",
    category: "business",
    fulltext: "Which company provides your gas and electricity at home? (If you have more than one, select the company that supplies your electricity.)",
    client: ["octopus", "octoenergy", "stack-data-strategy"],
    // This question IS the provider split, so comparing it by provider is
    // circular (Octopus customers are 100% Octopus) and the demographic filters
    // just shrink the base. Both are hidden for this question only — the other
    // energy questions keep them.
    hideProviderCompare: true,
    hideDemographicFilters: true,
    keys: [
      "ind:provider:octopus:cat",
      "ind:provider:british_gas:cat",
      "ind:provider:edf:cat",
 "ind:provider:ovo:cat",
 "ind:provider:scottish_power:cat",
  "ind:provider:eon:cat",
  "ind:provider:other:cat",
 "ind:provider:dk:cat"
    ],
    labels: {
      "ind:provider:octopus:cat":"Octopus Energy",
      "ind:provider:british_gas:cat":"British Gas",
      "ind:provider:edf:cat":"EDF Energy",
 "ind:provider:ovo:cat":"Ovo Energy",
 "ind:provider:scottish_power:cat":"Scottish Power",
  "ind:provider:eon:cat":"E.ON / E.ON Next (formerly nPower)",
  "ind:provider:other:cat":"Other",
 "ind:provider:dk:cat":"Don't know",

    },
    colors: {
  "ind:provider:scottish_power:cat":"#68BD68",
 "ind:provider:ovo:cat":"#0B9928",
  "ind:provider:other:cat":"#777777",
   "ind:provider:octopus:cat":"#FF71CF",
 "ind:provider:eon:cat":"#EA1C0A",
  "ind:provider:edf:cat":"#FE5716",
 "ind:provider:dk:cat":"#BDBDBD",
"ind:provider:british_gas:cat":"#002F87"
    },
    schema: "energy",
    waves: [5]
  },
  sector_importance_energy: {
    type: "categorical",
    label: "Sector importance",
    category: "business",
    fulltext: "When thinking about the future of the UK economy, which sectors do you think are most important? Please select up to three.",
    client: ["octopus", "octoenergy", "stack-data-strategy"],
    keys: [
      "ind:importance:big_tech:cat",
      "ind:importance:energy:cat",
      "ind:importance:water:cat",
      "ind:importance:oil_gas:cat",
      "ind:importance:healthcare:cat",
      "ind:importance:supermarkets:cat",
      "ind:importance:construction:cat",
      "ind:importance:farming:cat",
      "ind:importance:gambling:cat",
      "ind:importance:banks:cat",
      "ind:importance:online:cat",
      "ind:importance:propertydev:cat",
      "ind:importance:hospitality:cat",
      "ind:importance:defence:cat",
      "ind:importance:other:cat",
      "ind:importance:dk:cat",
    ],
    labels: {
      "ind:importance:big_tech:cat":     "Technology and social media companies",
      "ind:importance:energy:cat":       "Energy companies (gas, electricity)",
      "ind:importance:oil_gas:cat":       "Oil & Gas",
      "ind:importance:water:cat":        "Water and utility companies",
      "ind:importance:healthcare:cat":   "Healthcare, life sciences & pharma",
      "ind:importance:supermarkets:cat": "Retailers and supermarkets",
      "ind:importance:construction:cat": "Construction, property & housebuilding",
      "ind:importance:farming:cat":      "Farming and food production",
      "ind:importance:gambling:cat":     "Gambling companies and bookmakers",
      "ind:importance:banks:cat":        "Banks, insurance & financial services",
      "ind:importance:online:cat":       "Online retailers",
      "ind:importance:propertydev:cat":  "Property developers & housebuilders",
      "ind:importance:hospitality:cat":  "Hospitality (restaurants, hotels)",
      "ind:importance:defence:cat":      "Defence contractors",
      "ind:importance:other:cat":        "Other",
      "ind:importance:dk:cat":           "Don't know",
    },
    colors: {
      "ind:importance:big_tech:cat":     "#7B1FA2",
      "ind:importance:energy:cat":       "#F57C00",
      "ind:importance:water:cat":        "#0097A7",
      "ind:importance:healthcare:cat":   "#D81B60",
      "ind:importance:supermarkets:cat": "#388E3C",
      "ind:importance:construction:cat": "#F9A825",
      "ind:importance:farming:cat":      "#33691E",
      "ind:importance:gambling:cat":     "#C62828",
      "ind:importance:banks:cat":        "#1565C0",
      "ind:importance:online:cat":       "#00897B",
      "ind:importance:propertydev:cat":  "#8D6E63",
      "ind:importance:hospitality:cat":  "#FB8C00",
      "ind:importance:defence:cat":      "#37474F",
      "ind:importance:other:cat":        "#777777",
      "ind:importance:oil_gas:cat": "#795548",
      "ind:importance:dk:cat":           "#BDBDBD",
    },
    schema: "energy",
    waves: [5]
  },

  // =========================================================================
  // SECTOR TRUST — GRID (parent group, references sub-variables below)
  // =========================================================================
 

  trust_energy_energy: {
    type: "likert",
    label: "Trust: Energy companies",
    category: "business",
    fulltext: "To what extent do you trust each of the following sectors to act in the best interests of the public? Energy companies (e.g., gas, electricity)",
    client: ["octopus", "octoenergy", "stack-data-strategy"],
    keys: [
      "ind:trust_energy:trust_completely:cat",
      "ind:trust_energy:tend_trust:cat",
      "ind:trust_energy:neither:cat",
      "ind:trust_energy:tend_distrust:cat",
      "ind:trust_energy:no_trust:cat",
      "ind:trust_energy:dk:cat",
    ],
    labels: {
      "ind:trust_energy:trust_completely:cat": "Trust completely",
      "ind:trust_energy:tend_trust:cat":       "Tend to trust",
      "ind:trust_energy:neither:cat":          "Neither trust nor distrust",
      "ind:trust_energy:tend_distrust:cat":    "Tend to distrust",
      "ind:trust_energy:no_trust:cat":         "Do not trust at all",
      "ind:trust_energy:dk:cat":               "Don't know",
    },
    polarity: {
      pos: ["ind:trust_energy:trust_completely:cat", "ind:trust_energy:tend_trust:cat"],
      neu: "ind:trust_energy:neither:cat",
      neg: ["ind:trust_energy:tend_distrust:cat", "ind:trust_energy:no_trust:cat"],
      dk:  "ind:trust_energy:dk:cat",
    },
    schema: "energy",
    waves: [5]
  },




};
